import { useMostRecentSponsorship } from '@rhg/hooks/use-most-recent-sponsorship';
import { usePartnerById } from '@rhg/hooks/use-partner';

export const usePartnerDisplayLogic = () => {
    const {
        mostRecentSponsorship,
        isFetched: isSponsorshipFetched,
        isEnabled: isSponsorshipFetchEnabled,
    } = useMostRecentSponsorship();
    const {
        partner,
        isFetched: isPartnerFetched,
        isEnabled: isPartnerFetchEnabled,
    } = usePartnerById(mostRecentSponsorship?.recentSponsor?.partnerId);
    const isDisabled = !isSponsorshipFetchEnabled || !isPartnerFetchEnabled;

    if (isDisabled) {
        return {
            showReferrals: undefined,
            showScreeningResults: undefined,
            isLoading: false,
        };
    }

    if (!isSponsorshipFetched || !isPartnerFetched) {
        return {
            showReferrals: undefined,
            showScreeningResults: undefined,
            isLoading: true,
        };
    }

    const surveyConfig = partner?.surveyConfigs?.[0];
    return {
        showReferrals: !partner?.hideAllReferrals,
        showScreeningResults: !!surveyConfig?.showScreeningResults,
        isLoading: false,
    };
};
